import { render, staticRenderFns } from "./TitleDetailSideInfos.vue?vue&type=template&id=442f6182&scoped=true"
import script from "./TitleDetailSideInfos.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetailSideInfos.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetailSideInfos.vue?vue&type=style&index=0&id=442f6182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442f6182",
  null
  
)

export default component.exports